<template>
    <footer class="mini-footer">
        <nav>
            <div class="container">
                <ul class="menu">
                    <li>
                        <router-link to="/abuotUs" title="درباره ما">درباره ما</router-link>
                    </li>
                    <li>
                        <router-link to="/privacy" title="حریم خصوصی">حریم خصوصی</router-link>
                    </li>
                    <li>
                        <router-link to="/rules" title="تماس با ما">تماس با ما</router-link>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="copyright-bar">
            <div class="container" v-if="baseInfo != null">
                <p>
                    استفاده از مطالب {{baseInfo.ShopName}} فقط برای مقاصد غیرتجاری و با ذکر منبع بلامانع است.
                    کلیه حقوق این سایت متعلق
                    به شرکت {{baseInfo.ShopName}} می‌باشد.
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        }
    }
</script>

<style scoped>
</style>